import type { Sport } from '#src/__generated__/globalTypes.ts';
import { INVITE } from '#src/constants/__generated__/routes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useInviteLink = (sport?: Sport) => {
  const { generateSportContextPath, sport: currentSport } = useSportContext();

  return generateSportContextPath(INVITE, {
    sport: sport || currentSport,
  });
};
